let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("br5B5")).then(() => parcelRequire('g1ao0'));